import axios from 'axios'
import { apiService, getCookieValue, checkCookieExists } from '../common-services'
import { BASE_URL } from './../../config'


export const getStudentsBySearchData = async (searchType, searchData, session) => {
  try {
    if (!checkCookieExists('schoolCode')) {
      throw new Error('School_Code cookie not found!')
    }
    const schoolCode = getCookieValue('schoolCode')
    const loginId = getCookieValue('Login_Id')
    const formData = new FormData()
    formData.append('getStudentsBySearchData', '1')
    formData.append('searchType', searchType)
    formData.append('searchData', searchData)
    formData.append('session', session)
    formData.append('schoolCode', schoolCode)
    formData.append('loginId', loginId)
    const response = await apiService(`${BASE_URL}/api-controller/student/getStudentData.php`, 'POST', formData, {
      'Content-Type': 'multipart/form-data',
    })
    return response
  } catch (error) {
    console.error('Error fetching student details:', error)
    throw error
  }
}
export const toggleLogin = async (studentId, status, session, additionalData = {}, files = []) => {
  try {
    if (!checkCookieExists('schoolCode')) {
      throw new Error('School_Code cookie not found!')
    }
    const schoolCode = getCookieValue('schoolCode')
    const loginId = getCookieValue('Login_Id')
    const formData = new FormData()
    formData.append('toggleLogin', '1')
    formData.append('studentId', studentId)
    formData.append('status', status)
    formData.append('schoolCode', schoolCode)
    formData.append('loginId', loginId)
    const response = await apiService(`${BASE_URL}/api-controller/student/getStudentData.php`, 'POST', formData, {
      'Content-Type': 'multipart/form-data',
    })
    return response
  } catch (error) {
    console.error('Error fetching student details:', error)
    throw error
  }
}
export const getStudentDetailsById = async (
  studentId,
  session,
  additionalData = {},
  files = [],
) => {
  try {
    if (!checkCookieExists('School_Code')) {
      throw new Error('School_Code cookie not found!')
    }
    const schoolCode = getCookieValue('School_Code')
    const loginId = getCookieValue('Login_Id')
    const formData = new FormData()
    formData.append('getStudentDetails', '1')
    formData.append('studentId', studentId)
    formData.append('session', session)
    formData.append('schoolCode', schoolCode)
    formData.append('loginId', loginId)
    const response = await apiService(`${BASE_URL}/api-controller/student/getStudentData.php`, 'POST', formData, {
      'Content-Type': 'multipart/form-data',
    })
    return response
  } catch (error) {
    console.error('Error fetching student details:', error)
    throw error
  }
}
export const updateStudentDetails = async (
  studentId,
  session,
  studentFormData,
  additionalData = {},
  files = [],
) => {
  try {
    if (!checkCookieExists('School_Code')) {
      throw new Error('School_Code cookie not found!')
    }
    const schoolCode = getCookieValue('School_Code')
    const loginId = getCookieValue('Login_Id')
    const formData = new FormData()
    formData.append('updateStudentDetails', '1')
    formData.append('studentId', studentId)
    formData.append('session', session)
    formData.append('studentFormData', studentFormData)
    formData.append('schoolCode', schoolCode)
    formData.append('loginId', loginId)
    const response = await apiService(`${BASE_URL}/api-controller/student/getStudentData.php`, 'POST', formData, {
      'Content-Type': 'multipart/form-data',
    })
    return response
  } catch (error) {
    console.error('Error fetching student details:', error)
    throw error
  }
}
export const getSiblingsInfo = async (studentid) => {
  try {
    const schoolCode = getCookieValue('schoolCode')
    const loginId = getCookieValue('loginId')
    const response = await apiService(
      `${BASE_URL}/universal_apis.php?get_siblinglist=1&studentid=${studentid}&schoolCode=${schoolCode}&loginId=${loginId}`,
      'GET',
    )
    return response
  } catch (error) {
    console.error('Error fetching student siblings:', error)
    throw error
  }
}

export const getAdmissionListReport = async (session, classId, fromDate, toDate) => {
  try {
    const schoolCode = getCookieValue('schoolCode')
    const loginId = getCookieValue('loginId')
    const response = await axios.get(
      `${BASE_URL}/api-controller/student/getStudentData.php?schoolCode=${schoolCode}&loginId=${loginId}&getShowLeaveDetails=1&session=${session}&classId=${classId}&fromDate=${fromDate}&toDate=${toDate}`,
    )
    return response
  } catch (error) {
    console.error('Error fetching admission list report:', error)
    throw error
  }
}

export const getDropOutReport = async (session) => {
  try {
    const schoolCode = getCookieValue('schoolCode')
    const loginId = getCookieValue('loginId')
    const response = await axios.get(
      `${BASE_URL}/api-controller/student/getStudentData.php?schoolCode=${schoolCode}&loginId=${loginId}&getDropOutReport=1&session=${session}`,
    )
    return response
  } catch (error) {
    console.error('Error fetching admission list report:', error)
    throw error
  }
}

export const getStudentCountReport = async (session) => {
  try {
    const schoolCode = getCookieValue('schoolCode')
    const loginId = getCookieValue('loginId')
    const response = await axios.get(
      `${BASE_URL}/api-controller/student/getStudentData.php?schoolCode=${schoolCode}&loginId=${loginId}&getClassReport=1&session=${session}`,
    )
    return response
  } catch (error) {
    console.error('Error fetching admission list report:', error)
    throw error
  }
}

export const getFeedBackReport = async (writeType, fromDate, toDate) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/GetWriteToSchoolReport1.php?get_write_to_school=1&write_type=${writeType}&fdate=${fromDate}&tdate=${toDate}`,
    )
    return response
  } catch (error) {
    console.error('Error fetching admission list report:', error)
    throw error
  }
}

export const getstudentTableHeads = async () => {
  const schoolCode = getCookieValue('School_Code')
  const loginId = getCookieValue('Login_Id')
  try {
    const response = await axios.get(
      `${BASE_URL}/api-controller/student/getStudentData.php?schoolCode=${schoolCode}&loginId=${loginId}&getStudentDataTableHeads=1`,
    )
    return response
  } catch (error) {
    console.error('Error fetching admission list report:', error)
    throw error
  }
}

export const getstudentReportTable = async (formData, selectedSections, checkedState) => {
  try {
    const schoolCode = getCookieValue('schoolCode')
    const loginId = getCookieValue('loginId')
    const params = new URLSearchParams()

    params.append('get_students_data', '1')
    params.append('schoolCode', schoolCode)
    params.append('loginid', loginId)
    params.append('class_sec_id_grp', selectedSections)

    const keyMap = {
      session: 'session',
      studentType: 'student_type',
      stream: 'stream',
      concessionCategory: 'discount',
      socialCategory: 'social_category',
      gender: 'gender',
      locality: 'locality',
      bloodgroup: 'blood_group',
      commCity: 'comm_city',
      guardianType: 'guardian_type',
      motherTongue: 'mother_tongue',
      religion: 'religion',
      nationality: 'nationality',
      activeStatus: 'enabled',
      blockedStatus: 'blocked_remarks',
      feeCategory: 'fee_group',
      otherCategory: 'other_catgory',
    }

    Object.keys(formData).forEach((key) => {
      const apiKey = keyMap[key] || key // fallback: keep original if no mapping
      params.append(apiKey, formData[key])
    })

    Object.keys(checkedState).forEach((colId, idx) => {
      if (checkedState[colId]) {
        params.append(`head${colId}`, 1)
      }
    })

    const response = await axios.get(
      `${BASE_URL}/StudentDataReport1.php?${params.toString()}`,
    )
    return response
  } catch (error) {
    console.error('Error fetching admission list report:', error)
    throw error
  }
}

export const getSearchTableData = async (searchBy, session) => {
  try {
    const schoolCode = getCookieValue('schoolCode')
    const loginId = getCookieValue('loginId')
    const response = await axios.get(
      `${BASE_URL}/RegistrationSearchController.php?Get_Table_Data=1&search_by=${searchBy}&class_ids=&session=${session}&admission_id=&schoolid=1&loginid=${loginId}`,
    )
    return response
  } catch (error) {
    console.error('Error fetching admission list report:', error)
    throw error
  }
}

export const rejectApplication = async (applicationNO) => {
  try {
    const schoolCode = getCookieValue('schoolCode')
    const loginId = getCookieValue('loginId')
    const response = await axios.get(
      `${BASE_URL}/RegistrationSearchController.php?reject_application=1&application_no=${applicationNO}&schoolid=1&loginid=${loginId}&schoolCode=${schoolCode}`,
    )
    return response
  } catch (error) {
    console.error('Error fetching admission list report:', error)
    throw error
  }
}

export async function getOtherOptionCategories() {
  try {
    return await axios.get(
      `${BASE_URL}/Other_Options_Controller.php?function=GetOtherOptions&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
    )
  } catch (err) {
    console.log('Error while getting other categories', err.message)
  }
}

export async function addOtherCategory(OptionName, ConcessionType, ConcessionValue) {
  try {
    return await axios.post(
      `${BASE_URL}/Other_Options_Controller.php?function=AddOption&OptionName=${OptionName}&ConcessionType=${ConcessionType}&ConcessionValue=${ConcessionValue}&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
    )
  } catch (err) {
    console.log('Error while adding other category', err.message)
  }
}

export async function deleteOtherCategory(formdata) {
  const res = await axios.post(
    `${BASE_URL}/Other_Options_Controller.php?schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
    formdata,
  )
  return res.data
}

export const updateOtherCategory = async (data) => {
  const res = await axios.post(`${BASE_URL}/Other_Options_Controller.php?schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`, data)
  return res.data
}

export const getFeeHeads = async (formData) => {
  try {
    const schoolCode = getCookieValue('schoolCode')
    const loginId = getCookieValue('loginId')
    const response = await axios.get(
      `${BASE_URL}/OnlineReg_AjaxController.php?type=get_fee_head_master&loginid=${loginId}&schoolCode=${schoolCode}`,
    )
    return response.data
  } catch (error) {
    console.error('Error fetching Fee Heads:', error)
    return []
  }
}
// export async function addFeeHead(data) {
//   const res = await axios.post(`${BASE_URL}/OnlineReg_AjaxController.php?`, data);
//   return res.data;
// }
export const addFeeHead = async (formData) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/OnlineReg_AjaxController.php?schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
      formData,
    )
    return response.data
  } catch (error) {
    console.error('Error adding Fee Head:', error)
    throw error
  }
}

export const updateFeeHead = async (formData) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/OnlineReg_AjaxController.php?schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
      formData,
    )
    return response.data
  } catch (error) {
    console.error('Error updating Fee Head:', error)
    throw error
  }
}

export const editFeeHead = async (formData) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/OnlineReg_AjaxController.php?schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
      formData,
    )
    return response.data
  } catch (error) {
    console.error('Error editing Fee Head:', error)
    throw error
  }
}

export const deleteFeeHead = async (formData) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/OnlineReg_AjaxController.php?schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
      formData,
    )
    return response.data
  } catch (error) {
    console.error('Error deleting Fee Head:', error)
    throw error
  }
}

export const getTcFields = async () => {
  try {
    const response = await axios.get(
      `${BASE_URL}/OnlineReg_AjaxController.php?type=GetTCFields&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
    )
    return response
  } catch (error) {
    console.error('Error fetching admission list report:', error)
    throw error
  }
}

export const getWardTypes = async () => {
  try {
    const response = await axios.get(
      `${BASE_URL}/Other_Options_Controller.php?Client_Type=NOCHECK&function=GetOtherOptions&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
    )
    return response
  } catch (error) {
    console.error('Error fetching admission list report:', error)
    throw error
  }
}

export const getAppFee = async (session, classId, stream, feeCategory) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/OnlineReg_AjaxController.php?type=get_app_fee&session=${session}&class_id=${classId}&stream=${stream}&other_category=${feeCategory}&is_online=0&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
    )
    return response
  } catch (error) {
    console.error('Error fetching app Fee :', error)
    throw error
  }
}

export const submitOfflineRegistration = async (formData) => {
  try {
    const schoolCode = getCookieValue('schoolCode')
    const loginId = getCookieValue('loginId')
    const data = new FormData()

    const sameKeys = {
      session: formData.session,
      fatherName: formData.fatherName,
      studentDOB: formData.studentDOB,
      studAdharCardNo: formData.studAdharCardNo,
      studNationality: formData.studNationality,
      raAddress: formData.raAddress,
      raCityDist: formData.raCityDist,
      raState: formData.raState,
      raCountry: formData.raCountry,
      raPinCode: formData.raPinCode,
      studLocality: formData.studLocality,
      commAddress: formData.commAddress,
      commCityDist: formData.commCityDist,
      commState: formData.commState,
      commCountry: formData.commCountry,
      commPinCode: formData.commPinCode,
      otherCategory: formData.otherCategory,
      transactionType: formData.transactionType,

      studentMiddleName: formData.studentMiddleName,
      studentLastName: formData.studentLastName,
      studBloodGroup: formData.studBloodGroup,
      fatherContactNo: formData.fatherContactNo,
      studentSocialCat: formData.studentSocialCat,
      fatherOccupation: formData.fatherOccupation,
      motherName: formData.motherName,
      placeOfBirth: formData.placeOfBirth,
      motherContactNo: formData.motherContactNo,
      motherOccupation: formData.motherOccupation,
      motherAnnualIncome: formData.motherAnnualIncome,
      rollNoChoice: formData.rollNoChoice,
      studTotalRegAmount: formData.studTotalRegAmount,
      studTotalFeeAmount: formData.studTotalFeeAmount,
      studTotalConcessAmount: formData.studTotalConcessAmount,
      studentGender: formData.studentGender,
      divyaang: formData.divyaang,
    }

    const mappedKeys = {
      studentFirstName: formData.studentname,
      fatherAdharCardNo: formData.fatherAadhaar,
      fatherQual: formData.fatherQualification,
      fatherAnnualIncome: formData.fatherAnnualIncome,
      motherAdharCardNo: formData.motherAadhaar,
      motherQual: formData.motherQualification,
      othersName: formData.guardianName,
      othersMobileNo: formData.guardianContactNo,
      othersQual: formData.guardianQualification,
      othersAnnualIncome: formData.guardianAnnualIncome,
      schoolLastAttended: formData.school_last_attended,
      studSmsContactNo: formData.phone,
      studEmailAddress: formData.email,
      studReligion: formData.religion,
      studMotherTongue: formData.motherTongue,
      testDate: formData.Test_Date,
      testTime: formData.Test_Time,
      fatherNationality: formData.Father_Nationality,
      motherNationality: formData.Mother_Nationality,
      fatherOfficeAdd: formData.F_Office_Add,
      motherOfficeAdd: formData.M_Office_Add,
      fatherOfficeContact: formData.F_Office_Contact,
      motherOfficeContact: formData.M_Office_Contact,
      fatherAdd: formData.F_Address,
      motherAdd: formData.M_Address,
      lastAttendedClass: formData.Last_Attended_Class,
      isLastBoardCBSE: formData.Is_Last_Board_CBSE,
      studPrevSchoolBoard: formData.Last_School_Board,
      apaarId: formData.APAAR_ID,
      penNo: formData.PEN_Number,
      udiseCode: formData.UDISE_Code,
      schoolRegdId: formData.School_Regd_Id,
      regDate: formData.regDate,
      onlineId: formData.onlineTxnId,
      studStream: formData.stream,
      studclassToApply: formData.classId,
      $otherCategory: formData.wardType,
    }

    const studentDetailsJson = JSON.stringify({
      ...sameKeys,
      ...mappedKeys,
    })

    data.append('offlineRegisteration', 1)
    data.append('schoolCode', schoolCode)
    data.append('loginId', loginId)
    data.append('admissionId', formData.admissionId)
    data.append('studentDetailsJson', studentDetailsJson)

    data.append('feeAmountArray', JSON.stringify(formData.feeAmountArray || []))
    data.append('headIdArray', JSON.stringify(formData.headIdArray || []))
    data.append('conAmountArray', JSON.stringify(formData.conAmountArray || []))
    data.append('netAmountArray', JSON.stringify(formData.netAmountArray || []))

    if (formData.studentPhoto) {
      data.append('studentPhoto', formData.studentPhoto)
    }

    const response = await axios.post(`${BASE_URL}/getStudentData.php`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })

    return response
  } catch (error) {
    console.error('Error submitting offline registration:', error)
    throw error
  }
}

export const editOfflineRegistration = async (formData) => {
  try {
    const schoolCode = getCookieValue('schoolCode')
    const loginId = getCookieValue('loginId')
    const data = new FormData()

    const sameKeys = {
      session: formData.session,
      fatherName: formData.fatherName,
      studentDOB: formData.studentDOB,
      studAdharCardNo: formData.studAdharCardNo,
      studNationality: formData.studNationality,
      raAddress: formData.raAddress,
      raCityDist: formData.raCityDist,
      raState: formData.raState,
      raCountry: formData.raCountry,
      raPinCode: formData.raPinCode,
      studLocality: formData.studLocality,
      commAddress: formData.commAddress,
      commCityDist: formData.commCityDist,
      commState: formData.commState,
      commCountry: formData.commCountry,
      commPinCode: formData.commPinCode,
      otherCategory: formData.otherCategory,
      transactionType: formData.transactionType,

      studentMiddleName: formData.studentMiddleName,
      studentLastName: formData.studentLastName,
      studBloodGroup: formData.studBloodGroup,
      fatherContactNo: formData.fatherContactNo,
      studentSocialCat: formData.studentSocialCat,
      fatherOccupation: formData.fatherOccupation,
      motherName: formData.motherName,
      placeOfBirth: formData.placeOfBirth,
      motherContactNo: formData.motherContactNo,
      motherOccupation: formData.motherOccupation,
      motherAnnualIncome: formData.motherAnnualIncome,
      rollNoChoice: formData.rollNoChoice,
      studTotalRegAmount: formData.studTotalRegAmount,
      studTotalFeeAmount: formData.studTotalFeeAmount,
      studTotalConcessAmount: formData.studTotalConcessAmount,
      studentGender: formData.studentGender,
      divyaang: formData.divyaang,
    }

    const mappedKeys = {
      studentFirstName: formData.studentname,
      fatherAdharCardNo: formData.fatherAadhaar,
      fatherQual: formData.fatherQualification,
      fatherAnnualIncome: formData.fatherAnnualIncome,
      motherAdharCardNo: formData.motherAadhaar,
      motherQual: formData.motherQualification,
      othersName: formData.guardianName,
      othersMobileNo: formData.guardianContactNo,
      othersQual: formData.guardianQualification,
      othersAnnualIncome: formData.guardianAnnualIncome,
      schoolLastAttended: formData.school_last_attended,
      studSmsContactNo: formData.phone,
      studEmailAddress: formData.email,
      studReligion: formData.religion,
      studMotherTongue: formData.motherTongue,
      testDate: formData.Test_Date,
      testTime: formData.Test_Time,
      fatherNationality: formData.Father_Nationality,
      motherNationality: formData.Mother_Nationality,
      fatherOfficeAdd: formData.F_Office_Add,
      motherOfficeAdd: formData.M_Office_Add,
      fatherOfficeContact: formData.F_Office_Contact,
      motherOfficeContact: formData.M_Office_Contact,
      fatherAdd: formData.F_Address,
      motherAdd: formData.M_Address,
      lastAttendedClass: formData.Last_Attended_Class,
      isLastBoardCBSE: formData.Is_Last_Board_CBSE,
      studPrevSchoolBoard: formData.Last_School_Board,
      apaarId: formData.APAAR_ID,
      penNo: formData.PEN_Number,
      udiseCode: formData.UDISE_Code,
      schoolRegdId: formData.School_Regd_Id,
      regDate: formData.regDate,
      onlineId: formData.onlineTxnId,
      studStream: formData.stream,
      studclassToApply: formData.classId,
      $otherCategory: formData.wardType,
    }

    const studentDetailsJson = JSON.stringify({
      ...sameKeys,
      ...mappedKeys,
    })

    data.append('offlineRegisterationEdit', 1)
    data.append('schoolCode', schoolCode)
    data.append('loginId', loginId)
    data.append('applicationId', formData.applicationId)
    data.append('studentDetailsJson', studentDetailsJson)

    data.append('feeAmountArray', JSON.stringify(formData.feeAmountArray || []))
    data.append('headIdArray', JSON.stringify(formData.headIdArray || []))
    data.append('conAmountArray', JSON.stringify(formData.conAmountArray || []))
    data.append('netAmountArray', JSON.stringify(formData.netAmountArray || []))

    if (formData.studentPhoto) {
      data.append('studentPhoto', formData.studentPhoto)
    }

    const response = await axios.post(
      `${BASE_URL}/api-controller/student/getStudentData.php`,
      data,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      },
    )

    return response
  } catch (error) {
    console.error('Error submitting offline registration:', error)
    throw error
  }
}

export const getEditRegistrationById = async (Application_Id) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/RegistrationEdit1.php?get_application_data&Application_Id=${Application_Id}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting religion', err.message) // Handle errors
  }
}

export const GetReligion = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(`${BASE_URL}/GetReligion.php?GetReligion=GetReligion&schoolCode=${schoolCode}&loginId=${loginId}`) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting religion', err.message) // Handle errors
  }
}

export const UpdateReligion = async (formdata) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  formdata.append('schoolCode', schoolCode)
  formdata.append('loginId', loginId)
  try {
    return await axios.post(`${BASE_URL}/EditReligion1.php?`, formdata)
  } catch (err) {
    console.log('Error while Updating Religion', err.message)
  }
}

export const DeleteReligion = async (formData) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.post(`${BASE_URL}/DeleteReligion1.php?schoolCode=${schoolCode}&loginId=${loginId}`, formData)
  } catch (err) {
    console.log('Error while deleting religion', err.message)
  }
}

export const saveReligionData = async (formdata) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  formdata.append('schoolCode', schoolCode)
  formdata.append('loginId', loginId)
  try {
    return await axios.post(`${BASE_URL}/AddReligion1.php?`, formdata)
  } catch (err) {
    console.log('Error while Saving Religion', err.message)
  }
}

export const getHouse = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(`${BASE_URL}/GetHouse.php?GetHouse=GetHouse&schoolCode=${schoolCode}&loginId=${loginId}`)
  } catch (err) {
    console.log('Error while getting house', err.message)
  }
}

export const saveHouseData = async (formdata) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  formdata.append('schoolCode', schoolCode)
  formdata.append('loginId', loginId)
  try {
    return await axios.post(`${BASE_URL}/AddHouse1.php?`, formdata)
  } catch (err) {
    console.log('Error while Saving House', err.message)
  }
}

export const updateHouse = async (formdata) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  formdata.append('schoolCode', schoolCode)
  formdata.append('loginId', loginId)
  try {
    return await axios.post(`${BASE_URL}/EditHouse1.php?`, formdata)
  } catch (err) {
    console.log('Error while Updating House', err.message)
  }
}

export const deleteHouse = async (formData) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  formData.append('schoolCode', schoolCode)
  formData.append('loginId', loginId)
  try {
    return await axios.post(`${BASE_URL}/DeleteHouse1.php?`, formData)
  } catch (err) {
    console.log('Error while deleting house', err.message)
  }
}

export const importFile = async (formdata) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  formdata.append('schoolCode', schoolCode)
  formdata.append('loginId', loginId)
  try {
    return await axios.post(
      `${BASE_URL}/api-controller/student/getStudentData.php?`,
      formdata,
    )
  } catch (err) {
    console.error('Error while import file', err.message)
  }
}

export const getApplicationConfigTableData = async () => {
  try {
    return await axios.get(
      `${BASE_URL}/OnlineReg_AjaxController.php?type=GetTCFields&GetTCFields=GetTCFields&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
    )
  } catch (err) {
    console.error('Error while getting table data', err.message)
  }
}

export const saveApplicationFieldConfigurationData = async (formdata) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  formdata.append('schoolCode', schoolCode)
  formdata.append('loginId', loginId)
  try {
    return await axios.post(`${BASE_URL}/OnlineReg_AjaxController.php`, formdata)
  } catch (err) {
    console.error('Error while saving data', err.message)
  }
}

export const getStudentConfigData = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/StudentConfiguration1.php?get_student_configuration=1&schoolCode=${schoolCode}loginid=${loginId}`,
    )
  } catch (err) {
    console.error('Error while getting config data', err.message)
  }
}

export const updateStudentConfig = async (formdata) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  formdata.append('schoolCode', schoolCode)
  formdata.append('loginId', loginId)
  try {
    return await axios.post(`${BASE_URL}/StudentConfiguration1.php`, formdata)
  } catch (err) {
    console.error('Error while updating data', err.message)
  }
}

export const getFeeHead = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/OnlineReg_AjaxController.php?type=get_fee_heads_with_details&schoolCode=${schoolCode}&loginid=${loginId}`,
    )
  } catch (err) {
    console.error('Error while getting fee heads', err.message)
  }
}

export const getApplicationClassDetailsTableData = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/OnlineReg_AjaxController.php?type=FetchOlrLink&FetchOlrLink=FetchOlrLink&schoolCode=${schoolCode}&loginid=${loginId}`,
    )
  } catch (err) {
    console.error('Error while getting table data', err.message)
  }
}

export const saveClassDetails = async (formdata) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  formdata.append('schoolCode', schoolCode)
  formdata.append('loginId', loginId)
  try {
    return await axios.post(`${BASE_URL}/OnlineReg_AjaxController.php`, formdata)
  } catch (err) {
    console.error('Error while saving data', err.message)
  }
}

export const saveClassEditDetails = async (formdata) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  formdata.append('schoolCode', schoolCode)
  formdata.append('loginId', loginId)
  try {
    return await axios.post(`${BASE_URL}/OnlineReg_AjaxController.php`, formdata)
  } catch (err) {
    console.error('Error while saving data', err.message)
  }
}

export const submitStudentAdmission = async (
  studentDetailsJson,
  QualificationArray,
  methodSubjectsArray,
  studentPhoto,
  fatherPhoto,
  motherPhoto,
  othersPhoto,
  admitFields = {},
) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  const formData = new FormData()

  formData.append('newStudentEntry', '1')
  formData.append('loginId', loginId)
  formData.append('schoolCode', schoolCode)

  formData.append('studentDetailsJson', JSON.stringify(studentDetailsJson))

  if (studentPhoto) formData.append('studentPhoto', studentPhoto)
  if (fatherPhoto) formData.append('fatherPhoto', fatherPhoto)
  if (motherPhoto) formData.append('motherPhoto', motherPhoto)
  if (othersPhoto) formData.append('othersPhoto', othersPhoto)

  formData.append('QualificationArray', JSON.stringify(QualificationArray))
  formData.append('methodSubjectsArray', JSON.stringify(methodSubjectsArray))

  Object.keys(admitFields).forEach((key) => {
    formData.append(key, admitFields[key])
  })

  try {
    return await axios.post(
      `${BASE_URL}/api-controller/student/getStudentData.php`,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      },
    )
  } catch (err) {
    console.log('Error while submitting student admission new student entry:', err.message)
    throw err
  }
}

export const editNewStudentEntry = async (
  studentDetailsJson,
  QualificationArray,
  methodSubjectsArray,
  studentPhoto,
  fatherPhoto,
  motherPhoto,
  othersPhoto,
  admissionId,
) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  const formData = new FormData()

  formData.append('newStudentEntry', '1')
  formData.append('loginId', loginId)
  formData.append('schoolCode', schoolCode)
  formData.append('admissionId', admissionId)

  formData.append('studentDetailsJson', JSON.stringify(studentDetailsJson))

  if (studentPhoto) formData.append('studentPhoto', studentPhoto)
  if (fatherPhoto) formData.append('fatherPhoto', fatherPhoto)
  if (motherPhoto) formData.append('motherPhoto', motherPhoto)
  if (othersPhoto) formData.append('othersPhoto', othersPhoto)

  formData.append('QualificationArray', JSON.stringify(QualificationArray))
  formData.append('methodSubjectsArray', JSON.stringify(methodSubjectsArray))

  try {
    return await axios.post(
      `${BASE_URL}/api-controller/student/getStudentData.php`,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      },
    )
  } catch (err) {
    console.log('Error while submitting student admission new student entry:', err.message)
    throw err
  }
}

export const getAllSubjects = async (class_Id, section, session, student) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/Subject_1.php?get_stud_sub_list=get_details&student_id=${student}&session=${session}&school_id=1&class_id=${class_Id}&sec_id=${section}&schoolCode=${schoolCode}&loginid=${loginId}`,
    )
  } catch (err) {
    console.error('Error while getting all subjects', err.message)
  }
}

export const getStudentSubjectTableData = async (class_Id, section, session, student) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/student/getStudentData.php?StudentSubjectTableBody=1&session=${session}&classId=${class_Id}&secId=${section}&studentId=&subjectId=&schoolCode=${schoolCode}&loginid=${loginId}`,
    )
  } catch (err) {
    console.error('Error while getting table Data', err.message)
  }
}

export const addSubjects = async (formdata) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  formdata.append('schoolCode', schoolCode)
  formdata.append('loginId', loginId)
  try {
    return await axios.post(
      `${BASE_URL}/StudentSubjectAllocation1.php`,
      formdata,
    )
  } catch (err) {
    console.error('Error while saving data', err.message)
  }
}

export const deleteSubject = (listId) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return axios.get(
      `${BASE_URL}/Subject_1.php?delete_stud_subject_list=delete_record&list_id=${listId}&schoolCode=${schoolCode}&loginId=${loginId}`,
    )
  } catch (err) {
    console.error('Error While deleting subject', err.message)
  }
}

export const getStudentSubjectReportTableData = async (
  class_Id,
  section,
  session,
  student,
  subject,
) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/student/getStudentData.php?StudentSubjectTableBody=1&session=${session}&classId=${class_Id}&secId=${section}&studentId=${student}&subjectId=${subject}&schoolCode=${schoolCode}&loginid=${loginId}`,
    )
  } catch (err) {
    console.error('Error while getting table Data', err.message)
  }
}

export const getSiblingReportTableData = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/SiblingReportController.php?GetSiblingDetails=GetSiblingDetails&schoolCode=${schoolCode}&loginid=${loginId}`,
    )
  } catch (err) {
    console.error('Error while getting table Data', err.message)
  }
}

export const getAdmissionDetailsById = async (admissionId) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/student/getStudentData.php?getStudentDetailsById=1&admissionId=${admissionId}&schoolCode=${schoolCode}&loginId=${loginId}`,
    )
  } catch (err) {
    console.error('Error while getting table Data', err.message)
  }
}

export const getOnlineStudentDetailsById = async (admissionId) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/student/getStudentData.php?getOnlineStudentDetailsById=1&admissionId=${admissionId}&schoolCode=${schoolCode}&loginId=${loginId}`,
    )
  } catch (err) {
    console.error('Error while getting table Data', err.message)
  }
}

export const getStudentRollNO = async (classId, sectionId, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/universal_apis.php?Client_Type=NOCHECK&get_roll_no_of_student_by_section=1&class_id=${classId}&section_id=${sectionId}&student_session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`,
    )
  } catch (err) {
    console.error('Error while getting table Data', err.message)
  }
}

export const getStudentSequenceNo = async (classId, session) => {
  //stage9.swiftcampus.com/AdmissionAdd_1.php?get_sequence_no=1&session=2025-2026&class_id=3
  https: try {
    return await axios.get(
      `${BASE_URL}/AdmissionAdd_1.php?get_sequence_no=1&session=${session}&class_id=${classId}schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
    )
  } catch (err) {
    console.error('Error while getting sequence no', err.message)
  }
}

// Get Student Id
export const getStudentId = async (classId, session, sequenceNo) => {
  //stage9.swiftcampus.com/AdmissionAdd_1.php?get_student_id=1&session=2025-2026&class_id=3&sequence_no=2823
  https: try {
    return await axios.get(
      `${BASE_URL}/AdmissionAdd_1.php?get_student_id=1&session=${session}&class_id=${classId}&sequence_no=${sequenceNo}&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
    )
  } catch (err) {
    console.error('Error while getting student id', err.message)
  }
}

// Get Admission Id
export const getAdmissionId = async (classId, session, sequenceNo) => {
  //stage9.swiftcampus.com/AdmissionAdd_1.php?get_admission_id=1&session=2025-2026&class_id=3&sequence_no=2823
  https: try {
    return await axios.get(
      `${BASE_URL}/AdmissionAdd_1.php?get_admission_id=1&session=${session}&class_id=${classId}&sequence_no=${sequenceNo}&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
    )
  } catch (err) {
    console.error('Error while getting admission id', err.message)
  }
}

export const getStudentConfiguration = async () => {
  const loginId = getCookieValue('loginId')
  const schoolCode = getCookieValue('schoolCode')
  try {
    return await axios.get(
      `${BASE_URL}/StudentConfiguration1.php?get_student_configuration=1&loginid=${loginId}&schoolCode=${schoolCode}`,
    )
  } catch (err) {
    console.error('Error while getting admission id', err.message)
  }
}

export const checkRollNoOfStudent = async (classId, sectionId, session, rollNo) => {
  const loginId = getCookieValue('loginId')
  const schoolCode = getCookieValue('schoolCode')
  try {
    return await axios.get(
      `${BASE_URL}/universal_apis.php?Client_Type=NOCHECK&check_roll_no_of_student=1&class_id=${classId}&section_id=${sectionId}&student_session=${session}&student_roll_no=${rollNo}&schoolCode=${schoolCode}&loginId=${loginId}`,
    )
  } catch (err) {
    console.error('Error while getting admission id', err.message)
  }
}

export const confirmAdmission = async (
  admissionId,
  admissionNo,
  studentId,
  sequenceNo,
  feeGroupName,
  studentRollNo,
) => {
  // fee_group_name=3&sequence_no=2823&student_id=2526002823&admission_confirm=&adminssion_id=2025006&admission_number=25262823&fee_cluster_id=&student_roll_no=53
  const loginId = getCookieValue('loginId')
  const schoolCode = getCookieValue('schoolCode')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/student/getStudentData.php?admissionConfirm=1&admissionId=${admissionId}&admissionNo=${admissionNo}&studentId=${studentId}&sequenceNo=${sequenceNo}&feeGroupName=${feeGroupName}&studentRollNo=${studentRollNo}&schoolCode=${schoolCode}&loginId=${loginId}`,
    )
  } catch (err) {
    console.error('Error while getting admission id', err.message)
  }
}

export const getAttendenceData = async(student_id , currentSession) => {
  try {
    return await axios.get (
      `${BASE_URL}/ParentAppAtt.php?Parameter=StudYearlyAttendance&student_id=${student_id}&session=${currentSession}&Client_Type=NOCHECK&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`
    )
  }
  catch(err) {
    console.error('Error while getting attendence Data',err.message)
  }
}

export const getExamData = async(student_id , currentSession) => {
  const loginId = getCookieValue('loginId')
  const schoolCode = getCookieValue('schoolCode')
  try {
    return await axios.get (
      `${BASE_URL}/RCStudentExamMarksApi.php?Client_Type=NOCHECK&Student_Id=${student_id}&Session=${currentSession}&School_Id=1&loginid=${loginId}&schoolCode=${schoolCode}`
    )
  }
  catch(err) {
    console.error('Error while getting exam Data',err.message)
  }
}
